const initialState = {
  isLoading: false,
  totalRegistros: 0,
  tipoMovimentoInsumo: [],
  id: 0,
  nome: '', 
  excluido: false
}

export function tipoMovimentoInsumo(state = initialState, action) {
  switch (action.type) {
    case 'FETCHED_ALL_TIPO_MOVIMENTO_INSUMO':
      return {
        ...state,
        tipoMovimentoInsumo: action.tipoMovimentoInsumo,
        totalRegistros: action.totalRegistros
      }
    case 'TIPO_MOVIMENTO_INSUMO_DETAIL':
      return action.tipoMovimentoInsumo
    case 'TIPO_MOVIMENTO_INSUMO_UPDATED':
      return state
    case 'TIPO_MOVIMENTO_INSUMO_CLEAR':
      return initialState
    case 'TIPO_MOVIMENTO_INSUMO_CLEAR_ALL':
      return {
        ...state,
        tipoMovimentoInsumo: []
      }
    case 'TIPO_MOVIMENTO_INSUMO_HANDLE_ON_CHANGE':
      return {
        ...state,
        [action.props]: action.value
      }
    case 'TIPO_MOVIMENTO_INSUMO_ISLOADING':
      return {
        ...state,
        isLoading: true
      }
    case 'TIPO_MOVIMENTO_INSUMO_NOTISLOADING':
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}
